import AssessmentTemplatesList from '@/views/shared/AssessmentTemplatesList'

function Assessments() {
    return <AssessmentTemplatesList title='pages.assessment_templates.title'/>
}

export default Assessments
